import { Tooltip } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: .4rem;
  gap: .2rem;
  border-radius: 0.2rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
`

export const Row = styled.div`
  display: flex;
  gap: 1.2rem;
`

export const Column = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: start;
  min-width: 28vw;
`

export const CustomButton = styled(ButtonMui)`
  width: 100%;   
  height: 1.8rem !important;
  margin-top: .5rem !important;
`

export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;
`

export const CounterTooltip = styled(Tooltip)``
